import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import cartIcon from '../../../../images/icons/bag.svg';
import styles from './Title.module.sass';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

function Title(props) {
  const { closeCart, lineItemsCount } = props;
  return (
    <div className={styles['title-and-close']}>
      <div className={styles['title-with-icon']}>
        <div className={styles.icon}>
          <img width="20" src={cartIcon} alt="" />
          <div className={styles['item-count']}>{lineItemsCount}</div>
        </div>
        <div className={styles.title}>My bag</div>
      </div>
      <ClickableDiv
        className={classNames(styles.close, 'close')}
        onClick={closeCart}
      />
    </div>
  );
}

Title.propTypes = {
  closeCart: PropTypes.func.isRequired,
  lineItemsCount: PropTypes.number.isRequired,
};

export default Title;
